/**
 * Application roles. LearnX has three actors: students who book sessions,
 * mentors who deliver them, and admins who operate the platform. Keep this
 * as the single source of truth — route guards, navigation, and Firestore
 * rules all key off these values.
 */

export const ROLES = Object.freeze({
  STUDENT: 'student',
  MENTOR: 'mentor',
  ADMIN: 'admin',
});

export const ALL_ROLES = Object.values(ROLES);

/**
 * Public sign-up is disabled — every account (student, mentor, admin) is
 * provisioned by an admin (see the `adminAccounts` Cloud Function + the admin
 * Accounts page). Kept as an empty list so nothing self-selects a role.
 */
export const SELF_SIGNUP_ROLES = Object.freeze([]);

/** Default landing route per role after authentication. */
export const ROLE_HOME = Object.freeze({
  [ROLES.STUDENT]: '/student/dashboard',
  [ROLES.MENTOR]: '/mentor/dashboard',
  [ROLES.ADMIN]: '/admin/dashboard',
});

/** Human-readable labels for UI. */
export const ROLE_LABEL = Object.freeze({
  [ROLES.STUDENT]: 'Student',
  [ROLES.MENTOR]: 'Mentor',
  [ROLES.ADMIN]: 'Admin',
});

/** Resolve a role's home route, falling back to the student dashboard. */
export function homeForRole(role) {
  return ROLE_HOME[role] || ROLE_HOME[ROLES.STUDENT];
}
